import {initializeApp} from 'firebase/app';
import {getMessaging, getToken, onMessage} from 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyBcOGa-VHCuQeSMbg-lwHPdvINAhJhvz-I',
  authDomain: 'snapp-express.firebaseapp.com',
  projectId: 'snapp-express',
  storageBucket: 'snapp-express.firebasestorage.app',
  messagingSenderId: '209103361409',
  appId: '1:209103361409:web:973d6f5219ce027de0c480',
  measurementId: 'G-X0JR4NNN6C'
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

export {messaging, getToken, onMessage};
